import { render } from "./dashboard-page.vue?vue&type=template&id=4e1e5e1c"
import script from "./dashboard-page.vue?vue&type=script&lang=js"
export * from "./dashboard-page.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__